import '../shared';

import { mountSimulator } from './mountSimulator';

const mapping = {
  '/': 'Simulation - Step 0.1',
  '/step-2': 'Simulation - Step 0.2',
  '/step-3': 'Simulation - Step 0.3',
  '/step-4': 'Simulation - Step 0.4',
  '/step-5': 'Simulation - Step 1',
  '/step-6': 'Simulation - Step 2',
  '/step-7': 'Simulation - Step 3',
  '/step-8': 'Simulation - Step 4',
};

const onLocationChange = (pathname, state) => {
  window.dataLayer.push({
    event: 'lead-simulation-analytics-v2',
    'leads-simulation-step': mapping?.[pathname] ?? pathname,
  });

  if (pathname === '/step-8') {
    window.dataLayer.push({
      event: 'lead-simulation-adwords',
    });
    window.dataLayer.push({
      event: 'simulation-done',
    });
    window.dataLayer.push({
      event: 'enhanced-tracking',
      Email: state.email,
      Phone: state.phoneNumber,
    });
  }
};

mountSimulator(
  () => import(/* webpackChunkName: "simulator-cozynergy" */ '@cozynergy/simulateur-cozynergy'),
  (props) => ({
    apis: props.apis,
    basename: window.location.pathname,
    onLocationChange,
    defaultValues: props.defaultValues,
  })
);
